import { Alert, Box, Button, FormControl, InputLabel, MenuItem, Select, Stack } from "@mui/material";
import { useBusinessContext } from "../BusinessContext";
import { useContext, useEffect, useState } from 'react';
import { AuthContext } from '../AuthContext';
import api from '../api/axios';
import LoadingIndicator from './LoadingIndicator';

export default function BusinessSelection() {
  const context = useBusinessContext();
  const auth = useContext(AuthContext);
  const [tenants, setTenants] = useState([]);
  const [tenantError, setTenantError] = useState('');
  const [tenantLoading, setTenantLoading] = useState(false);
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    let cancelled = false;
    if (!auth?.user) return;
    setTenantLoading(true); setTenantError(''); setTenants([]);
    api.get('/auth/tenants').then(response => {
      if (!Array.isArray(response.data)) throw new Error('Ungültige Mandantenauswahl.');
      if (!cancelled) setTenants(response.data);
    }).catch(error => {
      if (!cancelled) setTenantError(error.response?.data?.error || 'Mandantenauswahl konnte nicht geladen werden.');
    }).finally(() => { if (!cancelled) setTenantLoading(false); });
    return () => { cancelled = true; };
  }, [auth?.user, attempt]);
  const changeTenant = id => { auth.switchTenant(id).catch(() => {}); };
  const fields = [
    ["mandant", "Mandant", context.mandantId, auth?.user ? tenants : context.mandanten, auth?.user ? changeTenant : context.selectMandant],
    ["betrieb", context.selectedMandant?.BetriebTitel || "Betrieb", context.betriebId, context.betriebe, context.selectBetrieb],
    ["betriebsjahr", context.selectedMandant?.BetriebsjahrTitel || "Betriebsjahr", context.betriebsjahrId, context.betriebsjahre, context.selectBetriebsjahr],
  ];
  return <Box data-testid="business-selection" sx={{ px: 0.75, pt: 2, minHeight: 190 }}>
    <Stack spacing={1.5}>
      {fields.map(([key, label, value, rows, select]) => <FormControl key={key} size="small" fullWidth>
        <InputLabel id={`${key}-label`}>{label}</InputLabel>
        <Select labelId={`${key}-label`} label={label} value={rows.some(r => r.Id === value) ? value : ""}
          title={rows.find(r => r.Id === value)?.Name || label} disabled={!rows.length || auth?.switching || (key === 'mandant' && tenantLoading)}
          onChange={event => select(event.target.value)} sx={{ fontSize: "0.75rem" }}>
          {rows.map(row => <MenuItem key={row.Id} value={row.Id}>{row.Name}</MenuItem>)}
        </Select>
      </FormControl>)}
    </Stack>
    {(context.loading || tenantLoading) && <LoadingIndicator compact label="Auswahl wird geladen …" sx={{ mt: 1 }} />}
    {(tenantError || auth?.switchError) && <Alert severity="error" sx={{ mt: 1 }}>{tenantError || auth.switchError}
      {tenantError && <Button size="small" onClick={() => setAttempt(value => value + 1)}>Erneut versuchen</Button>}
    </Alert>}
    {context.error && <Alert severity="error" sx={{ mt: 1 }}>{context.error}<Button size="small" onClick={context.retry}>Erneut versuchen</Button></Alert>}
  </Box>;
}
